import { render } from "./Genre.vue?vue&type=template&id=4522c108&scoped=true"
import script from "./Genre.vue?vue&type=script&lang=js"
export * from "./Genre.vue?vue&type=script&lang=js"

import "./Genre.vue?vue&type=style&index=0&id=4522c108&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4522c108"

export default script